import React from "react";

const STEPS = [
  { key: "requested", label: "Requested" },
  { key: "opened", label: "Opened" },
  { key: "started", label: "Started" },
  { key: "applied", label: "Applied" },
];

export const funnelStage = (r) =>
  r.has_account ? 3 : r.apply_started_at ? 2 : r.link_opened_at ? 1 : 0;

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : null);

export const FunnelSteps = ({ r, prefix = "funnel" }) => {
  const stage = funnelStage(r);
  const dates = [r.created_at, r.link_opened_at, r.apply_started_at, null];
  return (
    <div className="flex items-center gap-1 flex-wrap font-body text-[10px] uppercase tracking-wider" data-testid={`${prefix}-steps-${r.id}`}>
      {STEPS.map((s, i) => (
        <React.Fragment key={s.key}>
          {i > 0 && <span className={i <= stage ? "text-[#14A89A]" : "text-zinc-700"}>→</span>}
          <span
            data-testid={`${prefix}-${s.key}-${r.id}`}
            title={dates[i] ? `${s.label} ${fmt(dates[i])}` : s.label}
            className={`px-1.5 py-0.5 border ${i <= stage ? "border-[#14A89A]/40 text-[#14A89A]" : "border-white/10 text-zinc-600"}`}
          >
            {s.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export const FunnelSummary = ({ rows }) => {
  const c = [0, 0, 0];
  rows.forEach((r) => { const s = funnelStage(r); if (s < 3) c[s] += 1; });
  return (
    <p className="font-body text-[11px] text-zinc-400 mt-2" data-testid="funnel-summary">
      <span className="text-zinc-300" data-testid="funnel-count-not-opened">{c[0]}</span> never opened their link ·{" "}
      <span className="text-zinc-300" data-testid="funnel-count-opened">{c[1]}</span> opened but didn't start ·{" "}
      <span className="text-zinc-300" data-testid="funnel-count-started">{c[2]}</span> started but didn't finish
    </p>
  );
};
